module.exports = __webpack_public_path__ + "img/BG-OB.c29fd7e2.jpg";